import { DefaultContainer } from '@/shared/ui';
import { MetaDecorator } from '@/shared/utils';
import { cookieHTML } from './cookieHTML';

const CookiePage = () => (
  <>
    <MetaDecorator
      description='meta.cookie.description'
      title='meta.cookie.title'
    />
    <DefaultContainer
      dangerouslySetInnerHTML={{
        __html: cookieHTML,
      }}
    />
  </>
);

export default CookiePage;
